import { fmt, zoned } from '@/utils/dates';
import { capitalizeFirstLetter } from '@/utils/strings';

export const formatTickMonth = (value: Date) => capitalizeFirstLetter(fmt(value, 'LLL'));

export const formatTickYear = (value: Date) => fmt(value, 'yyyy');

export const formatTickDate = (value: Date) => {
  const z = zoned(value);

  if (z.getMonth() === 0 && z.getDate() === 1) {
    return fmt(value, 'yyyy');
  }

  return `${fmt(value, 'yyyy')} ${capitalizeFirstLetter(fmt(value, 'LLL'))}`;
};
